/**
 * Tipo `Resultado` — ADR-034.
 *
 * El dominio NO lanza excepciones ante fallos esperables (slot ocupado, fuera de
 * ventana, cedula invalida). Devuelve un `Resultado` con un codigo estable, y quien
 * llama esta obligado por el compilador a contemplar el caso de error.
 *
 * Las excepciones quedan para lo verdaderamente excepcional: fallos de infraestructura
 * y violaciones de invariantes.
 */
/** Construye un resultado exitoso. */
export function exito(valor) {
    return { ok: true, valor };
}
/** Construye un resultado fallido. */
export function fallo(error) {
    return { ok: false, error };
}
/** Guarda de tipo para la rama exitosa. */
export function esExito(resultado) {
    return resultado.ok;
}
/** Guarda de tipo para la rama fallida. */
export function esFallo(resultado) {
    return !resultado.ok;
}
//# sourceMappingURL=resultado.js.map